// extracted by mini-css-extract-plugin
export var errorsContainer = "_tc-1";
export var link = "_tc-0";